import { useCallback, useEffect, useRef, useState } from "react";

export function useSound(url: string, volume = 1.0) {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const audio = new Audio(url);

    audio.loop = true;
    audio.volume = volume;

    audioRef.current = audio;

    const handlePause = () => setIsPlaying(false);
    const handlePlay = () => setIsPlaying(true);

    audio.addEventListener("pause", handlePause);
    audio.addEventListener("play", handlePlay);

    return () => {
      audio.pause();
      audio.currentTime = 0;

      audioRef.current = null;

      audio.removeEventListener("pause", handlePause);
      audio.removeEventListener("play", handlePlay);
    };
  }, [url, volume]);

  const toggleSound = useCallback(() => {
    const audio = audioRef.current;

    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play().catch((error: unknown) => {
        console.error("Audio play failed: ", error);
      });
    }
  }, [isPlaying]);

  return { isPlaying, toggleSound };
}
